import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app-config';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  constructor(private appConfig: AppConfig) {}

  getPreviewUrl(versionId: string, deliveryTargetCode: string): string {
    return `${this.appConfig.cmsApiBaseUrl}/api/weblink/preview?articleVersionId=${versionId}&deliveryTargetCode=${deliveryTargetCode}`;
  }
}
